import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const StyledCardType = styled.span`
	margin-bottom: 0px;
	color: ${getColor('dustyGray')};
	text-transform: uppercase;
`;

export const StyledCardTitle = styled.h5`
	color: ${getColor('gray')};
`;
